<template>
  <div>
    <div class="row my-1 d-flex align-items-center">
      <h5 class="m-0" :class="inline ? 'col-3' : 'col-4'">{{ label }}</h5>

      <div :class="inline ? 'col-3' : 'col-4'">
        <b-link
          v-if="urlFile && !deletedFile"
          class="text-primary"
          @click="onViewFile(urlFile)"
          :disabled="false"
        >
          <span>Documento Registrado</span>
        </b-link>

        <span v-if="!urlFile && valueIsLocalFile && !deletedFile">
          <b-link class="text-success" @click="onViewFileLocal(value)">
            <span>Nuevo Documento</span>
          </b-link>
        </span>

        <span v-else-if="!urlFile">No hay Archivo</span>

        <span v-if="deletedFile" class="text-danger">El archivo será eliminado</span>

        <b-button
          v-if="!deletedFile && !onlyView"
          size="sm"
          :variant="editFile ? 'warning' : ''"
          title="Editar Archivo"
          @click="onEditFile"
          style="padding: 8px; margin-left: 5px;"
        >
          <i class="fa-solid fa-pen" />
        </b-button>

        <b-button
          v-if="urlFile && !editFile && !noDelete && !onlyView"
          size="sm"
          variant="danger"
          title="Eliminar Archivo"
          @click="onDeleteFile(urlFile)"
          style="padding: 8px; margin-left: 5px;"
        >
          <i class="fa-solid fa-trash" />
        </b-button>

        <slot name="actions" />
      </div>

      <div v-if="editFile" class="col">
        <div v-if="!urlFileLocal">
          <b-form-file
            v-model="urlFileLocal"
            :state="Boolean(urlFileLocal)"
            placeholder="elija un archivo o arrastre aquí..."
            drop-placeholder="Drop file here..."
            browse-text="Buscar..."
            :accept="accept"
          />
        </div>

        <div v-if="urlFileLocal && !deletedFile">
          <b-link class="text-success" @click="onViewFileLocal(urlFileLocal)">
            <span>Nuevo Documento</span>
          </b-link>

          <b-button
            class="ml-1"
            size="sm"
            variant="outline-danger"
            title="Eliminar Archivo"
            @click="onRemoveFileLocal"
          >
            <i class="fa-solid fa-trash" />
          </b-button>
        </div>
      </div>
    </div>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      :rutaCompleta="isRutaCompleta"
      v-model="isModalFileVisible"
    />
  </div>
</template>

<script>
import { ModalViewFile } from '@/shared/components';

export default {
  name: "LoadFileInput",

  props: {
    value: {
      type: [File, Object, null, String],
      default: null,
    },
    urlFile: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Archivo a subir',
    },
    accept: {
      type: String,
      default: '.pdf, .png, .jpg, image/png, image/jpeg, application/pdf, .dcm'
    },
    noDelete: {
      type: Boolean,
      default: false,
    },
    onlyView: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    tokenImagen: {
      type: String,
      default: null,
    },
  },

  components: {
    ModalViewFile,
  },

  data() {
    return {
      isModalFileVisible: false,
      fileToView: null,
      isRutaCompleta: false,
      urlFileLocal: null,
      editFile: false,
      deletedFile: false,
    };
  },

  methods: {
    onViewFile(urlF) {
      // Determinar la URL basada en si es un DICOM y si hay token
      if (urlF && urlF.toLowerCase().endsWith('.dcm') && this.tokenImagen) {
        this.isRutaCompleta = false;
        this.fileToView = `/ver-dicom/${this.tokenImagen}/`; // URL correcta sin prefijo duplicado
      } else {
        this.isRutaCompleta = false;
        this.fileToView = urlF; // Usa urlFile para otros archivos
      }
      this.isModalFileVisible = true;
    },

    onViewFileLocal(file) {
      if (file === undefined) {
        console.warn('El archivo será eliminado.');
        return;
      }

      if (!(file instanceof File)) {
        console.error('file no es instancia de File');
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        this.fileToView = event.target.result;
        this.isModalFileVisible = true;
        this.isRutaCompleta = true;
      };
      fileReader.readAsDataURL(file);
    },

    onRemoveFileLocal() {
      this.urlFileLocal = null;
    },

    onEditFile() {
      this.editFile = !this.editFile;
      if (!this.editFile) this.urlFileLocal = null;
    },

    async onDeleteFile(urlFile) {
      const result = await this.$swal.fire({
        title: 'Eliminar Archivo',
        text: '¿Está seguro de eliminar el archivo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      this.deletedFile = true;
      this.$emit('eliminado', { url: urlFile, eliminado: true });
      this.urlFileLocal = undefined;
    },
  },

  watch: {
    urlFileLocal: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  computed: {
    valueIsLocalFile() {
      return this.value instanceof File;
    },
  },
};
</script>
